module.exports = __webpack_public_path__ + "static/media/check-out.5179dad1.png";